
if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();

      this.handleOutsideClick = this.handleOutsideClick.bind(this);
      this.handleTabClick = this.handleTabClick.bind(this);
    }

    connectedCallback() {
      this.tabs = new MinimogTheme.Tabs(this);

      // Initially keep all tab details closed
      this.classList.add("tabs-initially-closed");

      // Remove the default active tab on page load
      this.clearActiveTab();

      // Open details when customer clicks a tab button
      this.querySelectorAll(".m-tab-header").forEach((header) => {
        header.addEventListener("click", this.handleTabClick);
      });

      // Close details when customer clicks outside the tabs section
      document.addEventListener("click", this.handleOutsideClick);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index =
            (tabHeader && Number(tabHeader.dataset.index)) || 0;

          this.tabs && this.tabs.setActiveTab(index);
        });
      }
    }

    
clearActiveTab() {
  // Remove active classes from all tab buttons
  this.querySelectorAll(".m-tab-header").forEach((header) => {
    header.classList.remove("active", "is-active");
    header.setAttribute("aria-selected", "false");
  });

  // Remove active classes from all tab content
  this.querySelectorAll(".m-tab-content").forEach((content) => {
    content.classList.remove("active", "is-active");
  });

  // Remove active state from the content wrapper
  this.querySelectorAll(".m-tabs__content").forEach((content) => {
    content.classList.remove("active", "is-active");
  });

  // Reset Tabs internal state
  this.tabs.currentActiveIndex = -1;
  this.tabs.currentTab = null;
}

    handleTabClick(event) {
  // Allow the selected tab content to open
  this.classList.remove("tabs-initially-closed");

  // Make sure the clicked tab content opens immediately
  const header = event.currentTarget;
  const index = Number(header.dataset.index);

  if (this.tabs && !isNaN(index)) {
    this.tabs.setActiveTab(index);
  }
}

    handleOutsideClick(event) {
      // If click is outside the product information tabs,
      // close all tab details
      if (!this.contains(event.target)) {
        this.classList.add("tabs-initially-closed");

        // Remove selected tab styling
        this.clearActiveTab();
      }
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.handleOutsideClick);
    }
  }

  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}